import vars from '../helpers';

const checker = () => {
	const $aos = $('[data-aos]');

	$aos.each((i, e) => {
		if (!$(e).data('aos-delay')) {
			return;
		}

		if ($(e).offset().top > window.innerHeight) {
			$(e).attr('data-aos-delay', '0');
		}
	});
};

const init = () => {
	AOS.init({
		disable: innerWidth <= 1024,
		duration: 750,
		// easing: 'ease-out-quart',
		once: true,
	});

	vars.$document.on('aos:in:line', ({detail}) => {
		const $article = vars.$document.find('.js-article');
		const $title = $(detail);

		if (+$title.data('view') > 0) {
			return;
		}

		$title.data('view', '1');

		const id = $title.data('line');

		let lines;

		if (id === 1) {
			lines = [$article.find('.js-article-line-1'), $article.find('.js-article-line-2'), $article.find('.js-article-line-3')];
		}

		if (id === 4) {
			lines = [$article.find('.js-article-line-4'), $article.find('.js-article-line-5')];
		}

		if (id === 6) {
			lines = [$article.find('.js-article-line-6'), $article.find('.js-article-line-7')];
		}

		if (id === 8) {
			lines = [$article.find('.js-article-line-8'), $article.find('.js-article-line-9')];
		}

		if (id === 10) {
			lines = [$article.find('.js-article-line-10')];
		}

		vars.gsapCleaner(lines);

		const tl = gsap.timeline();

		if (+id === 1) {
			tl
				.from(lines, {
					onStart() {
						$(lines).each((i, line) => {
							line.removeClass('is-hidden-desktop');
						});
					},
					height: 0,
					duration: 3,
					clearProps: 'all',
				})
			;
		} else {
			tl
				.to(lines, {
					onStart() {
						$(lines).each((i, line) => {
							line.removeClass('is-hidden-desktop');
						});
					},
					width: '100%',
					duration: 1,
					clearProps: 'all',
				})
			;
		}

		vars.$html.on('article-aos-destroy', () => {
			$title.data('view', '-1');
		});

		// const $home = $title.closest('.js-home');

		// const $linesToRight = vars.$document.find('.js-line-to-right');
		// const $linesToBottom = vars.$document.find('.js-line-to-bottom');
		// // const $linesToTop = vars.$document.find('.js-line-to-top');

		// const $image1 = $home.find('.js-home-image-1');
		// const $image2 = $home.find('.js-home-image-2');
		// const $image3 = $home.find('.js-home-image-3');
		// const $image4 = $home.find('.js-home-image-4');
		// const $image5 = $home.find('.js-home-image-5');
		// const $image6 = $home.find('.js-home-image-6');
		// const $image7 = $home.find('.js-home-image-7');
		// const $image8 = $home.find('.js-home-image-8');
		// const $image9 = $home.find('.js-home-image-9');

		// console.log('hit');

		// const tl = gsap.timeline();

		// tl
		// 	.from($linesToRight, {
		// 		onStart() {
		// 			$linesToRight.removeClass('is-hidden-desktop');
		// 		},
		// 		x: '-100%',
		// 		duration: 1.5,
		// 		ease: 'none',
		// 		clearProps: 'all',
		// 	}, 1)
		// 	.from($linesToBottom, {
		// 		onStart() {
		// 			$linesToBottom.removeClass('is-hidden-desktop');
		// 		},
		// 		y: '-100%',
		// 		duration: 0.75,
		// 		ease: 'none',
		// 		clearProps: 'all',
		// 	}, 1.5)
		// 	.from($linesToTop, {
		// 		onStart() {
		// 			$linesToTop.removeClass('is-hidden-desktop');
		// 		},
		// 		y: '100%',
		// 		duration: 0.75,
		// 		ease: 'none',
		// 		clearProps: 'all',
		// 	}, 1.5)
		// 	.from([$image3, $image6], {
		// 		onStart() {
		// 			$image3.removeClass('is-hidden-desktop');
		// 			$image6.removeClass('is-hidden-desktop');
		// 		},
		// 		autoAlpha: 0,
		// 		duration: 0.75,
		// 		ease: 'none',
		// 		clearProps: 'all',
		// 	}, 2.5)
		// 	.from([$image2, $image7], {
		// 		onStart() {
		// 			$image2.removeClass('is-hidden-desktop');
		// 			$image7.removeClass('is-hidden-desktop');
		// 		},
		// 		autoAlpha: 0,
		// 		duration: 0.75,
		// 		ease: 'none',
		// 		clearProps: 'all',
		// 	}, 3)
		// 	.from([$image1, $image4, $image5, $image8, $image9], {
		// 		onStart() {
		// 			$image1.removeClass('is-hidden-desktop');
		// 			$image4.removeClass('is-hidden-desktop');
		// 			$image5.removeClass('is-hidden-desktop');
		// 			$image8.removeClass('is-hidden-desktop');
		// 			$image9.removeClass('is-hidden-desktop');
		// 		},
		// 		autoAlpha: 0,
		// 		duration: 0.75,
		// 		ease: 'none',
		// 		clearProps: 'all',
		// 	}, 3.5)
		// ;
	});
};

const refresh = () => {
	$('.aos-animate').removeClass('aos-animate');

	// $('.js-aos-obj').each((i, obj) => {
	// 	if (!$(obj).hasClass('is-hidden-desktop')) {
	// 		$(obj).addClass('is-hidden-desktop');
	// 	}
	// });
	$('.js-article-line').each((i, line) => {
		if (!$(line).hasClass('is-hidden-desktop')) {
			$(line).addClass('is-hidden-desktop');
			vars.$html.trigger('article-aos-destroy');
		}
	});

	setTimeout(() => {
		AOS.refreshHard();
	}, 50);

	setTimeout(() => {
		checker();
	}, 75);

	vars.$window.on('load.aos', AOS.refreshHard);

	vars.$html.on('aos-refresh.aos', () => {
		AOS.refresh();
	});
};

const destroy = () => {
	vars.$window.off('.aos');
};

const articleDestroy = () => {
	// $('.js-article-line').each((i, line) => {
	// 	if (!$(line).hasClass('is-hidden')) {
	// 		$(line).addClass('is-hidden');
	// 		vars.$html.trigger('article-aos-destroy');
	// 	}
	// });
};

const resize = () => {
	destroy();
	init();
};

export default {
	init,
	destroy,
	resize,
	refresh,
	articleDestroy,
};
